import { JobStatus } from "../Frames";

const STATS = [["Active jobs", "14"], ["On site now", "6"], ["Hours this week", "212.5"], ["Shifts pending", "3"]];
const JOBS = [
  { name: "Lot 12 Banksia Cres", sub: "Armstrong Creek · Coastline Homes", who: "Jack Murray", status: "On site" },
  { name: "27 Wattle St", sub: "Highton · Barwon Builders", who: "Liam O'Brien", status: "On site" },
  { name: "Unit 4/9 Ryrie St", sub: "Newtown · Bellarine Constructions", who: "Mia Russo", status: "In progress" },
  { name: "Lot 88 Federation Dr", sub: "Lucas · Coastline Homes", who: "Sam Nguyen", status: "Not started" },
];

export const OverviewBody = () => (
  <div className="space-y-3">
    <div className="grid grid-cols-4 gap-2.5">
      {STATS.map(([l, v]) => (
        <div key={l} className="rounded-lg bg-white border border-slate-200 p-3">
          <p className="text-[10px] text-slate-500">{l}</p>
          <p className="font-mono text-[20px] font-bold mt-1">{v}</p>
        </div>
      ))}
    </div>
    <div className="rounded-lg bg-white border border-slate-200">
      <div className="px-3 h-9 flex items-center justify-between border-b border-slate-100">
        <p className="font-display font-bold text-[13px]">Today&apos;s jobs</p>
        <span className="text-[10px] rounded-full bg-[#EA580C] text-white px-2.5 py-1 font-semibold">+ New job</span>
      </div>
      {JOBS.map((j) => (
        <div key={j.name} className="px-3 py-2.5 flex items-center gap-3 border-b border-slate-100 last:border-0">
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-[12px]">{j.name}</p>
            <p className="text-[10px] text-slate-500">{j.sub}</p>
          </div>
          <span className="text-[10px] text-slate-600 w-24">{j.who}</span>
          <span className="w-24 flex justify-end"><JobStatus s={j.status} /></span>
        </div>
      ))}
    </div>
  </div>
);
